import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { SharedModule } from '@/shared.module';
import type { SaveState } from '../../types/careplan-nnn.types';

/**
 * The evaluation-date cell of the careplan-NNN row table: a datepicker with
 * an autosave hint. Takes the epoch-millis value from the row and emits the
 * picked `Date` (or null) for the parent to persist.
 */
@Component({
  selector: 'app-nnn-evaluation-date-cell',
  standalone: true,
  imports: [SharedModule],
  templateUrl: './nnn-evaluation-date-cell.component.html',
  styleUrl: './nnn-evaluation-date-cell.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NnnEvaluationDateCellComponent {
  readonly labelKey = input.required<string>();
  readonly value = input<number | null>(null);
  readonly disabled = input(false);
  readonly saveState = input<SaveState>('');

  readonly dateChange = output<Date | null>();

  protected readonly dateValue = computed(() => {
    const millis = this.value();
    return millis ? new Date(millis) : null;
  });
}
